import * as React from 'react'
import { Menu, Dropdown } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

export default class MenuBar extends React.Component {
  render() {
    return (
      <Menu vertical={true} size={'large'}>
        <Menu.Item>
          <Menu.Header>Tài khoản</Menu.Header>
          <Menu.Menu>
            <Menu.Item as={Link} to={'/user/info'}>Thay đổi thông tin</Menu.Item>
            <Dropdown item={true} text="Nạp tiền">
              <Dropdown.Menu>
                <Dropdown.Header>bằng</Dropdown.Header>
                <Dropdown.Item as={Link} to={'/user/depositBank'}>Ngân hàng</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* <Menu.Item as={Link} to={'/user/deposit'}>Gửi tiền vào tài khoản</Menu.Item> */}
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item>
          <Menu.Header>Giao dịch</Menu.Header>
          <Menu.Menu>
            <Menu.Item as={Link} to={'/user/cart'}>Giỏ hàng</Menu.Item>
          </Menu.Menu>
          <Menu.Menu>
            <Menu.Item as={Link} to={'/user/transaction'}>Lịch sử giao dịch</Menu.Item>
          </Menu.Menu>
        </Menu.Item>
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/User/containers/MenuBar.tsx